import { ApiResponse, axiosInstance } from '@/lib/axios';
import { FetchParams, IPagination } from '@/types/general.type';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TChannel } from '../../_shared/types/channel.type';
// import { TChannelIntegration } from '../../_shared/types/channel-integration.type';

/**
 * Get List Google Play Store Channel Response Type
 */
export type TGetListGooglePlayStoreChannelResponse = ApiResponse<IPagination<TChannel>>;

export const getListGooglePlayStoreChannel = async (
  params: FetchParams
): Promise<TGetListGooglePlayStoreChannelResponse> => {
  const url = '/integration/google-playstore/org-channel';

  return axiosInstance.get(url, { params });
};

/**
 * Get List Google Play Store Channel React-Query Hook
 */
export const GET_LIST_GOOGLE_PLAY_STORE_CHANNEL_QUERY_KEY = 'get-list-google-play-store-channel';

export const getListGooglePlayStoreChannelQueryOptions = (params: FetchParams) => {
  return queryOptions({
    queryKey: [
      GET_LIST_GOOGLE_PLAY_STORE_CHANNEL_QUERY_KEY,
      {
        page: params?.page,
        limit: params?.limit,
        search: params?.search,
        sortDir: params?.sortDir,
      },
    ],
    queryFn: () => getListGooglePlayStoreChannel(params),
  });
};

type UseGetListGooglePlayStoreChannelOptions = {
  params: FetchParams;
  queryConfig?: QueryConfig<typeof getListGooglePlayStoreChannelQueryOptions>;
};

export const useGetListGooglePlayStoreChannel = ({ params, queryConfig }: UseGetListGooglePlayStoreChannelOptions) => {
  return useQuery({
    ...getListGooglePlayStoreChannelQueryOptions(params),
    ...queryConfig,
  });
};
